module.exports = __webpack_public_path__ + "media/application/images/ui/purchase/consumer-join-tick-160934643490f80f5b17d9dc4d035a94.jpg";